import React from 'react';
import PropTypes from 'prop-types';
import { StyledParagraph } from './styled';

class Paragraph extends React.PureComponent {
  static defaultProps = {
    maxLines: -1,
    size: 'default'
  };

  static propTypes = {
    maxLines: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    size: PropTypes.oneOf([
      'default', 'small', 'medium', 'large'
    ])
  };

  // TODO: Truncate komponents:
  // – apgriež tekstu, nepieļaujot vairāk teksta rindu par noteiktajām;
  // - novēro 'resize' eventu un atkārto nepieciešamās darbības, ja platums mainījies.

  /* componentDidMount() {
    if (window) {
      const { maxLines } = this.props;
      if (maxLines > 0) {
        const { height } = this._ref.getBoundingClientRect();
        let { lineHeight } = window.getComputedStyle(this._ref);
        let [,lineHeightInPx] = (/(\d+)/).exec(lineHeight) || [];
        lineHeightInPx = lineHeightInPx && parseInt(lineHeightInPx, 10);
        const numLines = (height / lineHeightInPx) >> 0;
      }
    }
  } */

  render() {
    const {size, className, children} = this.props;
    return (
      <StyledParagraph
        innerRef={c => this._ref = c}
        size={size}
        className={className}
      >
        {children}
      </StyledParagraph>
    );
  }
}

export default Paragraph;



// WEBPACK FOOTER //
// ./src/elements/Paragraph/Paragraph.jsx